import { default as React, useState } from 'react';
// import { Typer, HorizontalScroll } from '../components';
import { Typer } from 'react-typetool';
import { Playground } from '../components';

const HomePage = ({ children }) => {
  const [blinkCaret, setBlinkCaret] = useState(true);
  const [showCaret, setShowCaret] = useState(true);

  const onFinish = () => {
    setBlinkCaret(false);
    setShowCaret(false);
  }

  // const styleRef = (ref) => {
  //   ref.current.style.height = '40px';
  //   ref.current.style.width = '4px';
  //   ref.current.style.marginBottom = '2px';
  // }

  return (
    <div className='page homePage'>
      <div className='homePage__introContainer'>
        {/* <Typer text='I am Typetool' onFinish={onFinish} blink={blinkCaret} showCaret={showCaret} getCaretRef={styleRef} /> */}
        <Typer text='I am Typetool' classes="typer--intro" onFinish={onFinish} blink={blinkCaret} showCaret={showCaret} useDefaultStyle={false} />
      </div>

      <div className="homePage__links">
        <a href="https://github.com/Thomva/react-typetool">GitHub Repo</a>
        <a href="https://www.npmjs.com/package/react-typetool">react-typetool</a>
        <a href="https://github.com/Thomva">Thomva</a>
      </div>

      <Playground />
    </div>
  );
};

export default HomePage;
